import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    sendFeedback: translate({ id: 'giveFeedback.footer.sendFeedback' }),
    cancel: translate({ id: 'giveFeedback.footer.cancel' }),
  }))

  return api
}
